import {type StudyRecap} from "../../../dicom/Parser";

export function buildUploadFormData(parsedStudies: Map<string, StudyRecap>): FormData {
	const form = new FormData();

	for (const [studyUID, recap] of parsedStudies.entries()) {
		for (const file of recap.files) {
			const name = `${studyUID}__${file.name}`;
			form.append("files", file, name);
		}
	}

	return form;
}
